import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import MailLink from './MailLink';
import { SITE } from '../content/site';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="wrap footer-in">
        <div className="footer-brand">
          <Link to="/" className="brand">
            <Logo size={34} />
            <span>{SITE.name}</span>
          </Link>
          <p>
            Independent mobile app studio. Building for Android and iOS since{' '}
            {SITE.since}.
          </p>
          <MailLink className="footer-mail" subject="Hello AppNexa">
            Email the studio
          </MailLink>
        </div>

        <div className="footer-cols">
          <div>
            <h4>Studio</h4>
            <a href="/#work">What we build</a>
            <a href="/#process">Process</a>
            <a href="/#privacy-first">Privacy first</a>
            <Link to="/contact">Contact</Link>
          </div>
          <div>
            <h4>Legal</h4>
            <Link to="/privacy">Privacy policy</Link>
            <Link to="/terms">Terms of service</Link>
            <Link to="/delete-account">Delete your account</Link>
          </div>
          <div>
            <h4>Support</h4>
            <MailLink subject="App support">App support</MailLink>
            <MailLink subject="Privacy request">Privacy request</MailLink>
            <a
              href={`https://play.google.com/store/apps/dev?id=${SITE.playDeveloperId}`}
              target="_blank"
              rel="noreferrer"
            >
              Google Play
            </a>
          </div>
        </div>
      </div>

      <div className="wrap footer-base">
        <span>
          © {new Date().getFullYear()} {SITE.name}. All rights reserved.
        </span>
        <span>Play developer ID {SITE.playDeveloperId}</span>
      </div>
    </footer>
  );
}

export default Footer;
